import React from 'react';

const LoadingScreen = () => (
  <div className="flex items-center justify-center h-screen w-screen bg-gray-50">
    <div className="text-center">
      <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-gray-900 mx-auto mb-4"></div>
      <h2 className="text-xl font-medium text-gray-700">Loading Adstronaut AI...</h2>
    </div>
  </div>
);

export default LoadingScreen;